// Maps Supabase / API errors to user-friendly messages.
// Keep wording short, action-oriented, and consistent across screens.

export function friendlyAuthError(err: unknown): string {
  const raw =
    err instanceof Error
      ? err.message
      : typeof err === "string"
        ? err
        : err && typeof err === "object" && "message" in err
          ? String((err as { message: unknown }).message)
          : "Something went wrong. Please try again.";

  const m = raw.toLowerCase();

  if (m.includes("invalid login credentials") || m.includes("invalid email or password"))
    return "That email and password don't match. Double-check and try again.";
  if (m.includes("email not confirmed") || m.includes("email_not_confirmed"))
    return "Please verify your email address before signing in. Check your inbox for the verification link.";
  if (m.includes("user already registered") || m.includes("already exists"))
    return "An account with this email already exists. Try signing in instead.";
  if (m.includes("rate limit") || m.includes("too many"))
    return "Too many attempts. Please wait a moment and try again.";
  if (m.includes("password should be") || m.includes("weak password"))
    return "Please choose a stronger password (at least 8 characters).";
  if (m.includes("password") && m.includes("pwned"))
    return "This password has appeared in known data breaches. Please choose a different one.";
  if (m.includes("network") || m.includes("failed to fetch"))
    return "Can't reach the server. Check your connection and try again.";
  if (m.includes("session") && (m.includes("expired") || m.includes("missing")))
    return "Your session has expired. Please sign in again.";
  if (m.includes("invite has expired"))
    return "This invitation has expired. Ask your administrator for a new invite.";
  if (m.includes("invite already used"))
    return "This invitation has already been accepted.";
  if (m.includes("invite not found"))
    return "This invitation is invalid or has been revoked.";
  if (m.includes("does not match signed-in user"))
    return "This invite was issued to a different email address. Sign in with that account.";
  if (m.includes("not authenticated") || m.includes("unauthorized") || m.includes("jwt"))
    return "You need to be signed in to do that.";
  if (m.includes("token") && m.includes("expired"))
    return "This link has expired. Request a new one.";

  return raw;
}
